export default "/static/dashboard/build/app/img/v2/1a6d1001177aaffbf91de05ad4718c23.png";